import './PartyTag.css';
import type { Candidate } from '../contracts/static';
import { t } from '../copy/strings';
import { partyClass, partyOf } from '../theme/parties';

export interface PartyTagProps {
  /** Sigla (chave de Party) e número como o TSE publica ("13", "1310"): o número nunca é formatado. */
  candidate: Pick<Candidate, 'party_code' | 'number'>;
  /** `sm` (--fs-micro) dentro de linhas de lista; padrão --fs-label. */
  size?: 'md' | 'sm';
}

/** Sigla + número ("PT 13") na cor de texto do partido (§3.8); sem partido conhecido, só o número em --color-fg-3. */
export function PartyTag({ candidate, size = 'md' }: PartyTagProps) {
  const party = partyOf(candidate);
  const fallback = party.number === 0;
  const cls = ['party-tag', partyClass(party), size === 'sm' && 'party-tag--sm', fallback && 'party-tag--fallback']
    .filter(Boolean)
    .join(' ');
  return (
    <span class={cls} data-testid="party-tag">
      {fallback ? candidate.number : t('party.tag', { SIGLA: party.display, NUM: candidate.number })}
    </span>
  );
}
